<nav class="ms-nav-fixed ms-pink">
  <div class="nav-wrapper">
    <a class="brand-logo" (click)="toHome()"><img src="/assets/img/logo.png" />MediaSpirit</a>
    <ul class="right hide-on-med-and-down">
      <li *ngIf="cropResTool === true">
        <a (click)="AddCropRes()" matTooltip="Add Crop Resolution">
          <mat-icon>crop</mat-icon>
        </a>
      </li>
      <li>
        <a routerLink="/status" matTooltip="MediaSpirit status">
          <mat-icon>timeline</mat-icon>
        </a>
      </li>
      <li *ngIf="allowNewTags === true">
        <a (click)="openAddTag()" matTooltip="Add new tag(s)">
          <mat-icon>label_outline</mat-icon>
        </a>
      </li>
      <li *ngIf="allowTagManager === true">
        <a routerLink="/tag-manager" matTooltip="Tag manager">
          <mat-icon>label</mat-icon>
        </a>
      </li>
      <li *ngIf="allowImageUpload === true">
        <a routerLink="/image-upload" matTooltip="Upload new image(s)">
          <mat-icon>file_upload</mat-icon>
        </a>
      </li>
      <li class="ms-image-count-container">
        <a routerLink="/image-search" matTooltip="Search image(s)">
          <span class="ms-image-count">{{ searchTotalRows$ | async }}</span>
          <mat-icon>view_module</mat-icon>
        </a>
      </li>
      <li>
        <a [matTooltip]="'Logout'" (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
        </a>
      </li>
    </ul>
    <a class="mobile-menu-button" (click)="showMobileMenuItems()">
      <mat-icon>{{ showMobileMenu === true ? 'close' : 'menu' }}</mat-icon>
    </a>
    <div *ngIf="showMobileMenu === true" class="mobile-menu">
      <ul>
        <li *ngIf="cropResTool === true">
          <a (click)="AddCropRes()" matTooltip="Add Crop Resolution">
            <mat-icon>crop</mat-icon>
          </a>
        </li>
        <li>
          <a (click)="showMobileMenuItems()" routerLink="/status" matTooltip="MediaSpirit status">
            <mat-icon>timeline</mat-icon>
          </a>
        </li>
        <li *ngIf="allowNewTags === true">
          <a (click)="openAddTag()" matTooltip="Add new tag(s)">
            <mat-icon>label_outline</mat-icon>
          </a>
        </li>
        <li *ngIf="allowTagManager === true">
          <a (click)="showMobileMenuItems()" routerLink="/tag-manager" matTooltip="Tag manager">
            <mat-icon>label</mat-icon>
          </a>
        </li>
        <li *ngIf="allowImageUpload === true">
          <a (click)="showMobileMenuItems()" routerLink="/image-upload" matTooltip="Upload new image(s)">
            <mat-icon>file_upload</mat-icon>
          </a>
        </li>
        <li class="ms-image-count-container">
          <a (click)="showMobileMenuItems()" routerLink="/image-search" matTooltip="Search image(s)">
            <span class="ms-image-count">{{ searchTotalRows$ | async }}</span>
            <mat-icon>view_module</mat-icon>
          </a>
        </li>
        <li>
          <a [matTooltip]="'Logout'" (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<router-outlet class="ms-router-outlet"></router-outlet>
<img *ngIf="loading" src="/assets/img/logo-preloader.png" alt="..." class="logo-loading animate-flicker" />
